import React from 'react'

function GetRayBanPair() {
  return (
    <section className="get-a-free" id="get-a-free">
        <div className="row ">
            <div className="container">
                <div className="get-content-wrap">
                    <div className="get-content wow fadeInLeft">
                        <div className="title">
                            <h2>Get a Free Pair of <span className="red">Ray-Ban Meta Glasses</span></h2>
                        </div>
                        {/* <p>The first 50 subscribers will receive a <b>free pair of Ray-Ban Meta glasses.</b></p> */}
                        <p>Exclusively for First 50 subscribers from nonprofit organizations.</p>
                    </div>
                    <div className="popup-image wow zoomIn">
                        <img src="/images/firstFifty-images/glasses-img.png" alt="Glasses" />
                        <img className="grediant-glasses-img" src="/images/firstFifty-images/grediant-glasses-img.png" alt="Glasses" />
                    </div>
                    <div className="get-content-bottom wow fadeInRight">
                        <p>Perfect for recording short clips at conferences or <br />snapping content for social
                            media—completely hands-free.</p>
                        {/* <h3>Just another way we’re making video easier and more accessible.</h3> */}
                        <h3>Ready to make video simpler for your team? Join the First 50 today.</h3>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default GetRayBanPair